import React from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';

import VpVideoCompilationsTableHead from './VpVideoCompilationsTableHead';
import VpVideoCompilationsTableBody from './VpVideoCompilationsTableBody';
import VpVideoCompilationsTablePagination from './VpVideoCompilationsTablePagination';

export const VpVideoCompilationsTable = () => {
  return (
    <TableContainer>
      <Table>
        <VpVideoCompilationsTableHead />
        <VpVideoCompilationsTableBody />
      </Table>
      <VpVideoCompilationsTablePagination />
    </TableContainer>
  );
};

export default VpVideoCompilationsTable;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpVideoCompilationTable/VpVideoCompilationsTable.jsx